import { ReactNode } from 'react';
import { Breadcrumb, Hamburger } from 'components';
import * as S from './styles';

interface Props {
  hideBreadcrumb?: boolean;
  children?: ReactNode;
}

export function Header({ hideBreadcrumb = false, children }: Props) {
  return (
    <S.Wrapper>
      <Hamburger />
      {!hideBreadcrumb && <Breadcrumb />}
      {children}
    </S.Wrapper>
  );
}
